import { BottomSheet, Button, Loader, Typography } from '@bharatpe/bharat-ui';
import React, { useEffect, useState } from 'react';
import UPILogoWhiteCircular from 'assets/icons/Autopay/UPILogoWhiteCircular.png';
import { useDispatch } from 'react-redux';
import { checkPermissions, getURLParameter } from 'utils/nativeSupport';
import { isEmpty } from 'utils/Utils';
import { CollectAuth, TriggerNativeApiWrapper } from 'utils/nativeUpiHandler';
import { API_URL } from 'Services/CONSTANT';
import { sendEvent } from 'utils/Sentry';
import Toasty from 'components/atoms/Toasty';
import { ICollectRequestDetails, IMandateCollectRequest } from 'types';
import {
	RESET_SELECTED_SIM,
	SET_HOME_MODAL_VISIBILITY,
	SET_PENDING_MANDATE_COLLECT_REQUEST,
	SET_ONBOARDING_REDIRECTION_PAGE,
	SET_UPI_STEP,
	useUpiData,
	useUpiStep,
	SET_COLLECT_REDIRECTION_PAGE,
} from 'Slices';
import history from 'utils/History';
import { ONBOARDING_REDIRECTION_PAGE, UPISteps } from 'utils/CONSTANT';
import useUpiStatus from 'Hooks/useUpiStatus';
import { useLanguageConfig } from 'Slices/LanguageConfigSlice';

const AutopayCollectRequest: React.FC = () => {
	const dispatch = useDispatch();
	const profileDetails = useUpiData();
	const bankList = profileDetails?.upiProfileDetails?.user_banks || [];
	const [loading, setLoading] = useState(true);
	const [mandateCollectRequest, setMandateCollectRequest] = useState<IMandateCollectRequest>();
	const upiStatus = useUpiStatus(ONBOARDING_REDIRECTION_PAGE.PROFILE);
	const upiStepDetails = useUpiStep();
	const { upiStep, upiErr } = upiStepDetails;
	const { languageData } = useLanguageConfig();

	useEffect(() => {
		if ((upiStatus?.upiErr || upiStatus?.upiStep) && isEmpty(upiStepDetails) && !upiStatus?.loading) {
			dispatch(SET_UPI_STEP({ upiStep: upiStatus?.upiStep, upiErr: upiStatus?.upiErr, loading: upiStatus?.loading }));
		}
	}, [dispatch, upiStatus]);

	useEffect(() => {
		if (!isEmpty(getURLParameter(window.location.href, 'mandateId')) && !upiStatus?.loading) {
			const mandateId = getURLParameter(window.location.href, 'mandateId');
			(async () => {
				try {
					const data: any = await TriggerNativeApiWrapper(
						`${API_URL.pending_collect_request}/${mandateId}`,
						'GET',
						{},
						{},
					);
					setLoading(false);
					setMandateCollectRequest(data);
					dispatch(SET_COLLECT_REDIRECTION_PAGE('/account/upi-settings'));
					dispatch(SET_PENDING_MANDATE_COLLECT_REQUEST(data));
				} catch (err: any) {
					sendEvent(err);
					Toasty.error(err?.error || 'something went wrong');
					history.push({ pathname: '/account/upi-settings' });
				}
			})();
		}
	}, [upiStatus?.loading]);

	const setReclaimFlow = async () => {
		if (selectedBank) {
			// dispatch(SET_HOME_MODAL_VISIBILITY({ debitCardModal: true }));
			history.push({
				pathname: '/account/bank-list',
			});
		} else {
			Toasty.error('Something went wrong !!!');
		}
	};

	const checkUPIOnboarding = (fn: any) => {
		const permissions = checkPermissions();
		if (!isEmpty(upiStep)) {
			dispatch(
				SET_ONBOARDING_REDIRECTION_PAGE({
					source: ONBOARDING_REDIRECTION_PAGE.PROFILE,
					searchParam: getURLParameter(window.location.href, 'bank-account-id'),
				}),
			);
		}

		permissions.then((data: any) => {
			if (!data.READ_PHONE_STATE || !data.SEND_SMS) {
				dispatch(
					SET_HOME_MODAL_VISIBILITY({ permissionModal: { visible: true, primaryBtnText: languageData.SETUP_AUTOPAY } }),
				);
			} else {
				if (upiErr) {
					Toasty.error(upiErr);
					dispatch(SET_HOME_MODAL_VISIBILITY({ somethingWentWrong: true }));
					return;
				}

				switch (upiStep) {
					case UPISteps.UPGRADE:
						dispatch(RESET_SELECTED_SIM());
						history.push({ pathname: '/upi/sim-binding' });
						break;
					case UPISteps.UPI_ONBOARDING_COMPLETE:
						fn();
						break;
					case UPISteps.RECLAIM_STATUS:
						setReclaimFlow();
						break;
					case UPISteps.BANK_SCREEN:
						history.push({
							pathname: '/upi/bank-selection',
						});
						break;
				}
			}
		});
		return;
	};

	const onProceedClick = () => {
		history.push({ pathname: '/upi/collect-auto-pay-details' });
	};

	const onDeclineClick = async () => {
		const data: ICollectRequestDetails = await CollectAuth(mandateCollectRequest, '', bankList[0], 'R');
		if (data) {
			history.push({ pathname: '/account/upi-settings' });
		}
	};
	return loading || upiStatus?.loading ? (
		<Loader loading />
	) : (
		<BottomSheet visible={true} heading="" rounded>
			<div className="flex flex-column p4">
				<img src={UPILogoWhiteCircular} loading="lazy" height={48} width={48} />
				<Typography variant="Bold500 my4" component="span">
					Autopay request
				</Typography>
				<div className="flex flex-column grey-border br2 p2">
					<div className="flex flex-row flex-justify">
						<Typography variant="Regular300" component="span">
							Request from
						</Typography>
						<div className="flex flex-column text-right">
							<Typography variant="Regular300" component="span">
								{mandateCollectRequest?.payer_details?.name}
							</Typography>
							<Typography variant="Light200" className="grey" component="span">
								{mandateCollectRequest?.payer_details?.vpa}
							</Typography>
						</div>
					</div>
					<div className="horizontal-dashed-divider my4"></div>
					<div className="flex flex-row flex-justify">
						<Typography variant="Regular300" component="span">
							Amount
						</Typography>
						<Typography variant="Bold400" component="span">
							₹{mandateCollectRequest?.amount}
						</Typography>
					</div>
				</div>
			</div>
			<div className="flex flex-row p4">
				<Button variant="outlined" className="mr2 width-50" onClick={() => checkUPIOnboarding(onDeclineClick)}>
					DECLINE
				</Button>

				<Button className="width-50" onClick={() => checkUPIOnboarding(onProceedClick)}>
					PROCEED
				</Button>
			</div>
		</BottomSheet>
	);
};
export default AutopayCollectRequest;
